module.exports = __webpack_public_path__ + "img/5.dc728a01.png";